module.exports = __webpack_public_path__ + "img/home-nav-icon-06.36196c25.png";